/**
 * @Description 分为区分年份的表格（单行内展示第一年、第二年数据）
 */

import { FC, useEffect } from 'react';
// import cs from 'classnames';
// import styles from './entry.module.less';
import V2FormInputNumber from '@/common/components/Form/V2FormInputNumber/V2FormInputNumber';
import { isNotEmpty } from '@lhb/func';

const YearDataInput: FC<any> = ({
  form,
  formItemData,
  disabled,
  moduleConfig,
  record,
  columnItem,
  onChange,
}) => {
  const propertyIdentification = formItemData.identification;
  const { dataIndex } = columnItem || {};
  const { key, defaultValue } = record || {};

  const fieldName = [propertyIdentification, moduleConfig.key, dataIndex, key];

  useEffect(() => {
    defaultValue && form.setFieldValue(fieldName, defaultValue);
  }, [defaultValue]);

  const handleBlur = () => {
    // const allValue = form.getFieldsValue();
    // console.log('allValue', allValue);
    // console.log('YearDataInput handleBlur');
    onChange && onChange();
  };

  const renderInput = (record: any) => {
    return <V2FormInputNumber
      formItemConfig={{
        noStyle: true
      }}
      min={isNotEmpty(record.min) ? record.min : 0}
      max={isNotEmpty(record.max) ? record.max : (record.unit === '%' ? 100 : 999999999)}
      name={fieldName}
      placeholder={record.disabled ? '自动计算' : (disabled ? '未输入' : '请输入')}
      form={form}
      disabled={disabled || !!record?.disabled}
      rules={[{ required: !!record.required, message: `请输入${record.name}` }]}
      config={{
        addonAfter: record?.unit || '',
        precision: record?.precision || (record.unit === '%' ? 1 : 0),
        // onPressEnter: save,
      }}
      blur={handleBlur}
    />;
  };

  const renderName = (record: any) => {
    return <>
      {record?.required ? <span className='c-f23'>*</span> : ' '}{record?.name}
    </>;
  };

  return columnItem?.isInput ? renderInput(record) : renderName(record);
};

export default YearDataInput;
